/**
 * Test IDs for CRM Paywall feature
 */
export const CRM_PAYWALL_TEST_IDS = {
  paywall: (service: 'salesforce' | 'hubspot') =>
    `crm-limit-paywall-${service}`,

  message: (service: 'salesforce' | 'hubspot') =>
    `crm-limit-paywall-message-${service}`,

  upgradeButton: (service: 'salesforce' | 'hubspot') =>
    `crm-upgrade-button-${service}`,

  contactSalesButton: (service: 'salesforce' | 'hubspot') =>
    `crm-contact-sales-button-${service}`,
} as const;
